import store from '../store/index'

function copyToClipboard(text) {
    const dummy = document.createElement('input')
    document.body.appendChild(dummy)
    dummy.setAttribute('id', 'Cheivoh8')
    document.getElementById('Cheivoh8').value = text
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)

    store.dispatch('addMessage', {
        message: 'copy',
        type: 'success',
        locale: true
    })
}

export default copyToClipboard
